<template>
    <div class="row">
        <div v-bind:class="`col-${labelContainerColumnSize}`" v-if="label || tooltip">
            <label v-if="label" v-bind:for="inputId" class="control-label">{{label}}</label>
            
            <tooltip-circle 
                    v-if="tooltip" 
                    v-bind:text="tooltip"
                    
                    class="pull-right"
            ></tooltip-circle>
        </div>
        
        <div v-bind:class="`col-${inputContainerColumnSize}`">
            <slot v-bind:inputId="inputId"></slot>
        </div>
    </div>
</template>

<script>
    import {guid} from "../../../../Util/guid";
    
    import TooltipCircle from "../../../../Components/Util/TooltipCircle.vue";

    export default {
        name: "settings-editor-base",
        components: {TooltipCircle},
        created(){
            this.id = guid();
        },
        computed: {
            inputId(){
                return `SETTINGS_${this.id}`;
            }
        },
        data: () => ({
            id: null
        }),
        props: {
            labelContainerColumnSize: {
                type: Number,
                default: 12
            },
            inputContainerColumnSize: {
                type: Number,
                default: 12
            },
            
            label: String,
            tooltip: String
        }
    };
</script>
